import React from 'react';
import { Chart } from '~/shared/types/chart';
import { getLcn } from '~/utils/labeled-classnames';
import TagPill from '../../tags/TagPill';
import { Link } from 'react-router-dom';
import { chartShowPath } from '~/sites/music/routes/paths';

export default function ChartListItem({ chart }: { chart: Chart }) {
  const lcn = getLcn({
    chartListItem: [
      'text-sm p-3 bg-[#00859a] rounded-lg text-white overflow-hidden text-ellipsis',
      'text-left flex flex-col gap-4'
    ],
    chartTitle: 'line-clamp-1',
  });

  return (
    <Link className={lcn.chartListItem} to={chartShowPath(chart.id)}>
      <div className={lcn.chartTitle}>
        {chart.song_title}
      </div>

      <div className='flex gap-3 flex-wrap'>
        {chart.tags.map(tag =>
          <TagPill key={tag.id} tag={tag} />
        )}
      </div>
    </Link>
  );
}; 